import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, theme, Dropdown } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { clearAuth, getUser, api } from '../api';
import './MainLayout.css';

const { Header, Sider, Content } = Layout;

const SIDER_WIDTH = 220;

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [menus, setMenus] = useState([]);
  const [user, setUser] = useState(getUser());
  const navigate = useNavigate();
  const location = useLocation();
  const { token: { colorBgContainer } } = theme.useToken();

  useEffect(() => {
    const token = localStorage.getItem('ar_token');
    if (!token) { navigate('/login'); return; }

    api.get('/menus').then(res => {
      if (res.data.success) {
        const data = res.data.menus || [];
        // API already returns nested tree, convert to Ant Design Menu format
        const buildTree = (items) => items.map(m => ({
          key: m.path || `menu-${m.id}`,
          label: m.name,
          icon: null,
          children: m.children && m.children.length > 0 ? buildTree(m.children) : undefined,
        }));
        setMenus([...buildTree(data)]);
        // Store allowed paths
        const collectPaths = (items) => {
          let paths = [];
          for (const m of items) {
            if (m.path) paths.push(m.path);
            if (m.children) paths = paths.concat(collectPaths(m.children));
          }
          return paths;
        };
        const allowed = collectPaths(data);
        sessionStorage.setItem('ar_allowed_paths', JSON.stringify(allowed));
      }
    }).catch(() => {});

    api.get('/auth/me').then(res => {
      if (res.data.success) setUser(res.data.user);
    }).catch(() => {});
  }, []);

  const handleLogout = () => { clearAuth(); navigate('/login'); };

  // 嵌入模式：隐藏侧栏（仅 embed 页会设 sessionStorage.embed_mode）
  const isEmbed = sessionStorage.getItem('embed_mode') === '1';

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!isEmbed && (
      <Sider trigger={null} collapsible collapsed={collapsed} 
        width={SIDER_WIDTH}
        breakpoint="lg"
        collapsedWidth={0}>
        <div className="sidebar-logo">{collapsed ? '' : '到货签收平台'}</div>
        <Menu theme="dark" mode="inline" selectedKeys={[location.pathname]}
          items={menus} onClick={({key}) => navigate(key)} />
      </Sider>
      )}
      <Layout>
        <Header style={{ padding: '0 24px', background: colorBgContainer, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button type="text" icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} onClick={() => setCollapsed(!collapsed)} />
          <Dropdown menu={{ items: [{ key: 'logout', icon: <LogoutOutlined />, label: '退出登录', danger: true, onClick: handleLogout }] }}>
            <Button type="text" icon={<UserOutlined />}>{user?.ccusname || user?.cCusCode || '用户'}</Button>
          </Dropdown>
        </Header>
        <Content style={{ margin: 16, padding: 24, background: colorBgContainer, minHeight: 280 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
